var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgcircleErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_tick-circle",
    "data-name": "vuesax/bold/tick-circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_x",
    "data-name": "icon / x",
    d: "M7.829,7.029a.552.552,0,0,1,0,.8.552.552,0,0,1-.8,0L4,4.8.971,7.829A.519.519,0,0,1,.571,8a.519.519,0,0,1-.4-.171.552.552,0,0,1,0-.8L3.2,4,.171.971a.552.552,0,0,1,0-.8.552.552,0,0,1,.8,0L4,3.2,7.029.171a.552.552,0,0,1,.8,0,.552.552,0,0,1,0,.8L4.8,4Z",
    fill: "#f8f8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.333,0a8.333,8.333,0,1,0,8.333,8.333A8.347,8.347,0,0,0,8.333,0Z",
    transform: "translate(1.667 1.667)",
    fill: "#e61616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_action_x",
    "data-name": "icon / action / x",
    transform: "translate(6 5.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_x-2",
    "data-name": "icon / x",
    d: "M7.829,7.029a.552.552,0,0,1,0,.8.552.552,0,0,1-.8,0L4,4.8.971,7.829A.519.519,0,0,1,.571,8a.519.519,0,0,1-.4-.171.552.552,0,0,1,0-.8L3.2,4,.171.971a.552.552,0,0,1,0-.8.552.552,0,0,1,.8,0L4,3.2,7.029.171a.552.552,0,0,1,.8,0,.552.552,0,0,1,0,.8L4.8,4Z",
    transform: "translate(0)",
    fill: "#f8f8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgcircleErr);
export default __webpack_public_path__ + "static/media/SvgcircleErr.54d4b5e47342fa2a9bc3999716fb854d.svg";
export { ForwardRef as ReactComponent };